<div class="center-layout-box">
  <h2>
    <i class="fas fa-arrow-alt-circle-left"></i>
    左のメニューから行う作業を選択してください
  </h2>
</div>
